module.exports = __webpack_public_path__ + "img/zoom.b2b7bf3f.svg";